import ApiService from "@/core/services/api.service";

// Action types
export const GET_COMPANY_REGISTRATION_SETTING = "getCompanyRegistrationSetting";
export const UPDATE_COMPANY_REGISTRATION_SETTING =
  "updateCompanyRegistrationSetting";

export default {
  state: {
    path: "registration_setting"
  },
  getters: {},
  actions: {
    [GET_COMPANY_REGISTRATION_SETTING](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(
        `${context.state.path}_by_company/${payload.company_id}`
      );
    },
    [UPDATE_COMPANY_REGISTRATION_SETTING](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}_by_company/${payload.company_id}`,
        payload.data
      );
    }
  },
  mutations: {}
};
